/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    // models & collections
    Organizations = require('../collections/organizations'),
    Program = require('../models/program'),
    Programs = require('../collections/programs'),
    user = require('../models/user'),
    // views
    // Create = require('./create'),
    OrganizationDetails = require('./organizationDetails'),
    ProgramDetails = require('./programDetails'),
    ProgramsSummaries = require('./programsSummaries'),
    Table = require('./table'),
    // utilities
    // enumerations = require('../utilities/enumerations'),
    templates = require('../utilities/handlebars').templates;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'organizations card card-body hidden'
    },
    channels: {
        console: BackboneRadio.channel('console'),
        program: BackboneRadio.channel('program'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    childViewEvents: {
        'create:program':      'onCreateProgram',
        'edit:end':            'onEditEnd',
        'edit:start':          'onEditStart',
        'next:program':        'onNextProgram',
        'previous:program':    'onPreviousProgram',
        'select:row':          'onSelectRow',
        'select:program':      'onSelectProgram',
        'vacancy:countChanged': 'onVacancyCountChanged'
    },
    events: {
        'click button': 'onClickButton'
    },
    organizationId: null,
    regions: {
        table:               {el: 'div[name=table]',               replaceElement: true},
        organizationDetails: {el: 'div[name=organizationDetails]', replaceElement: true},
        programDetails:      {el: 'div[name=programDetails]',      replaceElement: true},
        programsSummaries:   {el: 'div[name=programsSummaries]',   replaceElement: true}
    },
    tagName: 'div',
    template: templates.organizations,
    //
    close: function () {
        if (this.getChildView('programDetails')) {
            this.getChildView('programDetails').close();
        }
    },
    initialize: function () {
        this.organizations = new Organizations([], {});
        this.programs = new Programs([], {via: 'organizations'});
        this.templateContext = function () {
            return {
                hasAdminAccess: user.hasCapability('administrator')
            };
        };
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.render();
        }, this));
        this.listenTo(this.organizations, 'add', _.bind(function (model) {
            // an organization has been created...
            console.log(model);
            this.onSelectRow(model);
        }, this));
        this.listenTo(this.programs, 'add', _.bind(function (model) {
            // a program has been created...
            // this.channels.console.trigger('log', 'programs.view.programs.change.id', true);
            _.defer(_.bind(function () { // give the create modal a chance to clean up...
                this.showProgramDetail(model, true);
            }, this));
        }, this));
        this.listenTo(this.channels.program, 'update', function (options) {
            if (!this.organizationId) {
                console.error('@organizations.initialize.listenTo.program - !this.organizationId');
                return;
            }
            if (this.programs.get(options.id)) {
                this.programs.organization(this.organizationId);
            }
        });
    },
    onClickButton: function (event) {
        // const templateContext = {};
        switch (event.currentTarget.dataset.action) {
            case 'add':
                this.onSelectRow(null);
                this.onEditStart();
                break;
            default:
                break;
        }
    },
    onCreateProgram: function () {
        this.showProgramDetail(new Program());
    },
    onEditEnd: function () {
        this.toggleAddEditDisable(false);
    },
    onEditStart: function () {
        this.toggleAddEditDisable(true);
    },
    onNextProgram: function (program) {
        // we rely on ProgramDetails view to not call us when at last program...
        this.showProgramDetail(this.programs.at(this.programs.indexOf(program) + 1));
    },
    onPreviousProgram: function (program) {
        // we rely on ProgramDetails view to not call us when at first program...
        this.showProgramDetail(this.programs.at(this.programs.indexOf(program) - 1));
    },
    onRender: function () {
        this.showChildView('table', new Table({title: null, collection: this.organizations, emptyMessage: 'noOrganizationsLabel'})); // @acavan!
        return this;
    },
    onSelectOrganizationById: function (organizationId) {
        this.onSelectRow(this.organizations.get(organizationId));
    },
    onSelectProgramById: function (organizationId, programId) {
        this.onEditStart();
        this.onSelectRow(this.organizations.get(organizationId), programId);
    },
    onSelectProgram: function (program) {
        this.onEditStart();
        this.showProgramDetail(program);
    },
    onSelectRow: function (model, programId) {
        _.each(['organizationDetails', 'programsSummaries'], _.bind(function (child) {
            const childView = this.getChildView(child);
            if (childView) {
                childView.destroy();
            }
        }, this));
        if (model) {
            this.organizationId = model.id;
            this.programs.organization(model.id);
            _.defer(_.bind(function () {
                this.showChildView('organizationDetails', new OrganizationDetails({model: model, organizationId: model.id}));
                this.showChildView('programsSummaries', new ProgramsSummaries({collection: this.programs, dashboard: true, via: 'organizations', show: programId || null}));
            }, this));
        } else {
            this.showChildView('organizationDetails', new OrganizationDetails({collection: this.organizations, model: null, organizationId: null}));
        }
        // mark the "selected" row, if any (including newly added ones or other results of non-clicks)
        this.getChildView('table').markRow(model ? model.id : null);
    },
    onVacancyCountChanged: function () {
        this.organizations.reload();
    },
    showProgramDetail: function (program, freshlyMinted) {
        const view = this.getChildView('programDetails');
        if (!view) {
            this.showChildView('programDetails', new ProgramDetails({model: program, collection: this.programs, offset: this.programs.indexOf(program) + 1, count: this.programs.length, freshlyMinted: freshlyMinted === true ? true : false}));
        } else {
            view.newModel({model: program, collection: this.programs, offset: this.programs.indexOf(program) + 1, count: this.programs.length, freshlyMinted: freshlyMinted === true ? true : false});
        }
        // request scroll to top
        this.channels.vaultOut.trigger('scrollToTop');
        // this.showChildView('programDetails', new ProgramDetails({model: program, collection: this.programs, offset: this.programs.indexOf(program) + 1, count: this.programs.length}));
    },
    toggleAddEditDisable: function (disable) {
        // console.log('organizations.toggleAddEditDisable');
        jQuery('[data-action=add]', this.$el).attr('disabled', disable);
        jQuery('[data-action=edit]', this.$el).attr('disabled', disable);
        jQuery('[data-action=select]', this.$el).attr('disabled', disable);
        this.getChildView('table').disable(disable);
    }
});
